import Model from '@models/model';

export const CONTACT_TYPE_CUSTOMER = 'Customer';
export const CONTACT_TYPE_VENDOR = 'Vendor';
export default class Contact extends Model {
    resource() {
        return 'contacts';
    }

    getBillingContacts() {
        return this.where('is_billing_contact', true)
            .list()
            .get();
    }

    getDeliveryContacts() {
        return this.where('is_delivery_contact', true)
            .list()
            .get();
    }

    getSalesContacts() {
        return this.where('is_sales_contact', true)
            .list()
            .get();
    }

    getServiceContacts() {
        return this.where('is_service_contact', true)
            .list()
            .get();
    }
}
